import {Component, inject} from '@angular/core'
import version from '../assets/package.json'
import {HeaderComponent} from './common/header/header.component'
import {RouterOutlet} from '@angular/router'
import {FooterComponent} from '@sparbanken-syd/sparbanken-syd-theme'
import {ConfigService} from '@sparbanken-syd/sparbanken-syd-bankid'

@Component({
  selector: 'spb-root',
  templateUrl: './app.component.html',
  imports: [
    HeaderComponent,
    RouterOutlet,
    FooterComponent
  ]
})
export class AppComponent {
  public version = version.version
  public configService = inject(ConfigService)
}
